import { JobType } from "./representative"
import {
	AssetType,
	PositionType,
} from "./asset"

export class CreateRepresentativeRequest
{
	id?: string | null
	name?: string | null
	email?: string | null
	phone?: string | null
	job?: JobType | null
}

export class RequisiteRequest
{
	preferredContractTypes?: { [id: string]: boolean }|null
	preferredAssetType?: AssetType|null
	minGla?: number|null
	maxGla?: number|null
	minLandArea?: number|null
	maxLandArea?: number|null
	positionType?: PositionType|null
	shopWindows?: boolean|null
	singleLevel?: boolean|null
}

export class BrandProfileUpdateRequest
{
	name?: string|null
	company?: string|null
	representative?: CreateRepresentativeRequest|null
	products?: string[]|null
	requisites: RequisiteRequest[] = []
}
